import React, { useState } from "react";
// React Bootstrap
import { Navbar, Image, Form, FormControl, InputGroup } from "react-bootstrap";
// Components
import GenericExplorer from "../generic/GenericExplorer";
import GrupoTrabajoTarjeta from "./GruposTrabajoTarjeta";
import GruposTrabajoTarjetaAdd from "./GruposTrabajoTarjetaAdd";
// Styled Components
import styled from "styled-components";
// Contexto
import { levelTeams } from "../../contexto";
import TooltipIcon from "../generic/TooltipIcon";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
`;

const GruposTrabajo = ({ direccionGeneral, ...props }) => {
  // TODO quitar coger los parametro asi ponerlo en el root
  const idProvincia = direccionGeneral ? direccionGeneral : props.computedMatch.params.id_p;

  const [search, setSearch] = useState("");
  const [missionLevel, setMissionLevel] = useState("");
  const [todosGrupos, setTodosGrupos] = useState(false);

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };
  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    let count = "20";
    let findName = search ? search : "";

    return `?count=${count}&findName=${findName}&level=${missionLevel}`;
  };

  const handleChangeLevelEquipos = (e) => {
    setMissionLevel(e.target.value);
  };

  const handleChangeTodosGrupos = () => {
    setTodosGrupos(!todosGrupos);
  };

  return (
    <>
      <h2>Equipos/Comisiones {direccionGeneral && "de la Dirección General"}</h2>
      <GenericExplorer 
        url={todosGrupos ? `/provincias/${idProvincia}/gruposTrabajo${getQueryString()}&todosGrupos=true` : `/provincias/${idProvincia}/gruposTrabajo${getQueryString()}`} 
        ItemCard={GrupoTrabajoTarjeta} 
        ItemAddCard={GruposTrabajoTarjetaAdd}
        userLevel={props.userLevel}
        >
        <CustomNavBar expand="md">
          {/* Cuando se hace pequeña la pantalla */}
          <Navbar.Toggle aria-controls="Filtro Grupo Trabajo" className="bg-light mb-3">
            <Image className="align-text-top" alt="" height="20" />
            <span className="align-text-bottom"> Filtros</span>
          </Navbar.Toggle>
          {/*          */}
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
            <Form as="div" inline className="w-100">
              <FormControl type="text" onChange={handleChangeSearch} placeholder={"Búsqueda"} className="mr-3" />
              {direccionGeneral && (
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Nivel"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control as="select" custom onChange={handleChangeLevelEquipos} value={missionLevel}>
                    <option value={""} key="empty">
                      Todos
                    </option>
                    {levelTeams.map((level) => (
                      <option value={level} key={level}>
                        {level}
                      </option>
                    ))}
                  </Form.Control>
                </InputGroup>
              )}
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label={`Todos los grupos/comisiones ${direccionGeneral ? "de la Dirección General" : "de la provincia"}`} defaultChecked={todosGrupos} value={todosGrupos} onClick={handleChangeTodosGrupos} />
                  <TooltipIcon className={"ml-1 pb-1"} content={`Al seleccionar esta opción se muestran todos los grupos/comisiones ${direccionGeneral ? "de la Dirección General" : "de la provincia"}`} />
                </Form.Group>
              </InputGroup>
            </Form>

          </Navbar.Collapse>
        </CustomNavBar>
      </GenericExplorer>
    </>
  );
};

export default GruposTrabajo;
